export default __webpack_public_path__ + "static/media/blog-driveway-pattern-banner.17cfa1cd.jpg";